// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"696c6264","453":"e2778b36"}[chunkId] + ".chunk.js";
};